import { useState } from 'react'

import { ApolloError } from '@apollo/client'
import {
  VideosUrlsFromLocaleDocument,
  VideosUrlsFromLocaleQuery,
} from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'

type Video = NonNullable<
  VideosUrlsFromLocaleQuery['publicVideos']['videosConnection']['nodes']
>[number]

type Return = [Video[] | undefined, boolean, ApolloError | undefined]

const FALLBACK_LOCALE = 'en-us'

export const useDiscoveryModalVideos = (providedLocale: string): Return => {
  const [locale, setLocale] = useState(providedLocale)
  const { data, loading, error } = useQuery(VideosUrlsFromLocaleDocument, {
    variables: {
      locale: locale,
      category: 'performance',
    },
  })

  const videos = loading ? undefined : data?.publicVideos.videosConnection.nodes

  useEffect(() => {
    // we check there are videos... complete here
    if (!error && !loading && videos?.length === 0 && locale !== FALLBACK_LOCALE) {
      setLocale(FALLBACK_LOCALE)
    }
  }, [loading, Boolean(error), videos?.length])

  return [videos, loading, error]
}
